import { formatPriceExact } from '../../../utils/priceFormatter';

const PriceCell = ({ value }: any) => (
  <div className="price-cell-container">
    <span className="price-value">{value ? `$${formatPriceExact(value)}` : '--'}</span>
  </div>
);
export default PriceCell;
